export class UploadResp {
  Progress:number;
  Obj:any;
}
